import { useEffect } from 'react';
import { scrollToLandingHashFromLocation } from '../utils/landingScroll';
import { FeatureShowcase } from './FeatureShowcase';
import { Hero } from './Hero';
import { LandingHeader } from './LandingHeader';
import { LegalFooter } from './legal/LegalFooter';

export function LandingPage() {
  useEffect(() => {
    document.body.classList.add('landing-scroll-lock');
    scrollToLandingHashFromLocation();

    return () => {
      document.body.classList.remove('landing-scroll-lock');
    };
  }, []);

  return (
    <>
      <LandingHeader />
      <div
        id="landing-scroll-root"
        className="landing-mobile-scroll max-md:h-[100svh] max-md:overflow-y-auto max-md:overscroll-y-contain max-md:snap-y max-md:snap-mandatory"
      >
        <Hero />
        <FeatureShowcase />
        <LegalFooter />
      </div>
    </>
  );
}
